// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"trusted-by_section-wrapper__WhgLQ","description":"trusted-by_description__uuJwA","list":"trusted-by_list__140Xy"};